export enum OpportunityCostExperimentGroups {
  Control = 'control',
  VariantA = 'varianta',
  VariantB = 'variantb',
  VariantC = 'variantc',
}

export enum PriceFramingLanguageExperimentGroups {
  Control = 'control',
  VariantA = 'varianta',
  VariantB = 'variantb',
}

export enum TestimonialsIntegrationExperimentGroups {
  Control = 'control',
  Variant = 'variant',
}

export enum SinglePageUpgradeModalExperimentGroups {
  Control = 'control',
  Variant = 'variant',
}
